import { emptySplitApi as api } from "../../../emptyApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    apiPortalV1AssessmentsPlansTeamList: build.query<
      ApiPortalV1AssessmentsPlansTeamListApiResponse,
      ApiPortalV1AssessmentsPlansTeamListApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/assessments/plans/team/`,
        params: {
          assessment_period_id: queryArg.assessmentPeriodId,
          debrief_schedule_id: queryArg.debriefScheduleId,
        },
      }),
    }),
    apiPortalV1AssessmentsPlansTeamCreate: build.mutation<
      ApiPortalV1AssessmentsPlansTeamCreateApiResponse,
      ApiPortalV1AssessmentsPlansTeamCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/assessments/plans/team/`,
        method: "POST",
        body: queryArg.teamAssessmentPeriodActionPlan,
      }),
    }),
    apiPortalV1AssessmentsPlansTeamRetrieve: build.query<
      ApiPortalV1AssessmentsPlansTeamRetrieveApiResponse,
      ApiPortalV1AssessmentsPlansTeamRetrieveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/assessments/plans/team/${queryArg.id}/`,
      }),
    }),
    apiPortalV1AssessmentsPlansTeamUpdate: build.mutation<
      ApiPortalV1AssessmentsPlansTeamUpdateApiResponse,
      ApiPortalV1AssessmentsPlansTeamUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/assessments/plans/team/${queryArg.id}/`,
        method: "PUT",
        body: queryArg.teamAssessmentPeriodActionPlan,
      }),
    }),
    apiPortalV1AssessmentsPlansTeamPartialUpdate: build.mutation<
      ApiPortalV1AssessmentsPlansTeamPartialUpdateApiResponse,
      ApiPortalV1AssessmentsPlansTeamPartialUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/assessments/plans/team/${queryArg.id}/`,
        method: "PATCH",
        body: queryArg.patchedTeamAssessmentPeriodActionPlan,
      }),
    }),
    apiPortalV1AssessmentsPlansTeamDestroy: build.mutation<
      ApiPortalV1AssessmentsPlansTeamDestroyApiResponse,
      ApiPortalV1AssessmentsPlansTeamDestroyApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/assessments/plans/team/${queryArg.id}/`,
        method: "DELETE",
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as portalApi };
export type ApiPortalV1AssessmentsPlansTeamListApiResponse =
  /** status 200  */ TeamAssessmentPeriodActionPlanRead[];
export type ApiPortalV1AssessmentsPlansTeamListApiArg = {
  assessmentPeriodId: number;
  debriefScheduleId: number;
};
export type ApiPortalV1AssessmentsPlansTeamCreateApiResponse =
  /** status 201  */ TeamAssessmentPeriodActionPlanRead;
export type ApiPortalV1AssessmentsPlansTeamCreateApiArg = {
  teamAssessmentPeriodActionPlan: TeamAssessmentPeriodActionPlan;
};
export type ApiPortalV1AssessmentsPlansTeamRetrieveApiResponse =
  /** status 200  */ TeamAssessmentPeriodActionPlanRead;
export type ApiPortalV1AssessmentsPlansTeamRetrieveApiArg = {
  /** A unique integer value identifying this assessment period action plan. */
  id: number;
};
export type ApiPortalV1AssessmentsPlansTeamUpdateApiResponse =
  /** status 200  */ TeamAssessmentPeriodActionPlanRead;
export type ApiPortalV1AssessmentsPlansTeamUpdateApiArg = {
  /** A unique integer value identifying this assessment period action plan. */
  id: number;
  teamAssessmentPeriodActionPlan: TeamAssessmentPeriodActionPlan;
};
export type ApiPortalV1AssessmentsPlansTeamPartialUpdateApiResponse =
  /** status 200  */ TeamAssessmentPeriodActionPlanRead;
export type ApiPortalV1AssessmentsPlansTeamPartialUpdateApiArg = {
  /** A unique integer value identifying this assessment period action plan. */
  id: number;
  patchedTeamAssessmentPeriodActionPlan: PatchedTeamAssessmentPeriodActionPlan;
};
export type ApiPortalV1AssessmentsPlansTeamDestroyApiResponse = unknown;
export type ApiPortalV1AssessmentsPlansTeamDestroyApiArg = {
  /** A unique integer value identifying this assessment period action plan. */
  id: number;
};
export type TeamAssessmentPeriodActionPlan = {
  leader?: number | null;
  team?: number | null;
  assessment_period_id: number;
};
export type PhaseIdEnum = 1 | 2 | 3;
export type AssessmentPeriodActionPlanTaskStatusEnum =
  | 1
  | 2
  | 3
  | 4
  | 5
  | 6
  | 7;
export type AssessmentPeriodActionPlanTask = {
  phase_id?: PhaseIdEnum;
  activity_name?: string;
  b_corp_goal?: string | null;
  task_name?: string;
  task_sort_order?: number;
  activity_sort_order?: number;
  metric?: string | null;
  description: string;
  status?: AssessmentPeriodActionPlanTaskStatusEnum;
  start_date?: string | null;
  end_date?: string | null;
  notes?: string | null;
  resources?: any;
  content?: any;
  assessment_period_action_plan?: number;
  owner?: number | null;
};
export type ActionPlanStatusEnum = 1 | 2 | 3 | 4 | 5 | 11 | 99;
export type ActionPlan = {
  employee?: number | null;
  organization?: number | null;
  metric: string;
  primary?: string | null;
  assignees?: number[];
  sort_order?: number | null;
  plan?: any | null;
  question?: any | null;
  status?: ActionPlanStatusEnum;
  start_date: string;
  end_date: string;
  created_by?: number | null;
};
export type ActionPlanRead = {
  id: number;
  employee?: number | null;
  organization?: number | null;
  metric: string;
  primary?: string | null;
  assignees?: number[];
  sort_order?: number | null;
  plan?: any | null;
  question?: any | null;
  status?: ActionPlanStatusEnum;
  status_text: string;
  start_date: string;
  end_date: string;
  created_by?: number | null;
  created_at: string;
  updated_at: string;
};
export type AssessmentPeriodActionPlanTaskRead = {
  id: number;
  action_plan: ActionPlanRead;
  phase_id?: PhaseIdEnum;
  activity_name?: string;
  b_corp_goal?: string | null;
  task_name?: string;
  task_sort_order?: number;
  activity_sort_order?: number;
  metric?: string | null;
  description: string;
  status?: AssessmentPeriodActionPlanTaskStatusEnum;
  start_date?: string | null;
  end_date?: string | null;
  notes?: string | null;
  resources?: any;
  content?: any;
  assessment_period_action_plan?: number;
  owner?: number | null;
};
export type TeamAssessmentPeriodActionPlanRead = {
  id: number;
  leader?: number | null;
  team?: number | null;
  total_task_count: number;
  completed_task_count: number;
  percent_complete: number;
  assessment_period_id: number;
  debrief_schedule_id: number | null;
  assessmentperiodactionplantask_set: AssessmentPeriodActionPlanTaskRead[];
};
export type PatchedTeamAssessmentPeriodActionPlan = {
  leader?: number | null;
  team?: number | null;
  assessment_period_id?: number;
};
export type PatchedTeamAssessmentPeriodActionPlanRead = {
  id?: number;
  leader?: number | null;
  team?: number | null;
  total_task_count?: number;
  completed_task_count?: number;
  percent_complete?: number;
  assessment_period_id?: number;
  debrief_schedule_id?: number | null;
  assessmentperiodactionplantask_set?: AssessmentPeriodActionPlanTaskRead[];
};
export const {
  useApiPortalV1AssessmentsPlansTeamListQuery,
  useApiPortalV1AssessmentsPlansTeamCreateMutation,
  useApiPortalV1AssessmentsPlansTeamRetrieveQuery,
  useApiPortalV1AssessmentsPlansTeamUpdateMutation,
  useApiPortalV1AssessmentsPlansTeamPartialUpdateMutation,
  useApiPortalV1AssessmentsPlansTeamDestroyMutation,
} = injectedRtkApi;
